export const buildDownloadUrl = (
  artifactKey: string,
  version: string,
): string => {
  // If local, use the local mock server
  if (import.meta.env.DEV) {
    return `http://localhost:3001/api/download?artifactKey=${artifactKey}&version=${version}`;
  }
  // Otherwise, use the CloudFront URL
  return `/download?artifactKey=${artifactKey}&version=${version}`;
};

export const formatFileSize = (bytes: number): string => {
  const kilobytes = bytes / 1024;

  if (kilobytes < 1024) {
    return `${kilobytes.toFixed(1)} KB`;
  }

  const megabytes = kilobytes / 1024;

  return `${megabytes.toFixed(1)} MB`;
};
